import React, { useState } from "react";

const FILTER_OPTIONS = [
  { value: "", label: "الكل" },
  { value: "platform", label: "المنصات" },
  { value: "report", label: "التقارير" },
  { value: "monthly", label: "التقرير الشهري" },
];

const UpdatesTimeline = ({ updates = [], loading = false }) => {
  const [filter, setFilter] = useState("");

  const formatDate = (d) =>
    new Date(d).toLocaleDateString("ar-EG", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

  if (loading) {
    return (
      <div className="updates-wrapper">
        <p className="updates-empty">جاري تحميل التحديثات...</p>
      </div>
    );
  }

  if (!updates.length) {
    return (
      <div className="updates-wrapper">
        <p className="updates-empty">لا توجد تحديثات لعرضها حالياً</p>
      </div>
    );
  }

  const sorted = [...updates]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .filter((u) => !filter || u.type === filter);

  return (
    <div className="updates-wrapper">
      {/* ── فلتر ── */}
      <div className="updates-filter-bar">
        <span className="updates-filter-label">فلتر حسب القسم:</span>
        <div className="updates-filter-btns">
          {FILTER_OPTIONS.map((opt) => (
            <button
              key={opt.value}
              className={`updates-filter-btn ${filter === opt.value ? "active" : ""}`}
              onClick={() => setFilter(opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      {sorted.length === 0 ? (
        <p className="updates-empty">لا توجد نتائج لهذا الفلتر</p>
      ) : (
        <>
          {/* ── جدول (ديسكتوب) ── */}
          <div className="updates-content">
            <table className="updates-table">
              <thead>
                <tr>
                  <th>التاريخ</th>
                  <th>المكان / القسم</th>
                  <th>تفاصيل التحديث</th>
                </tr>
              </thead>
              <tbody>
                {sorted.map((u) => (
                  <tr key={u.id}>
                    <td data-label="التاريخ">{formatDate(u.date)}</td>
                    <td data-label="المكان / القسم">
                      <span className={`update-badge update-badge--${u.type}`}>
                        {u.target}
                      </span>
                    </td>
                    <td data-label="تفاصيل التحديث">{u.description || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ── تايم لاين (موبايل) ── */}
          <div className="updates-timeline">
            {sorted.map((u) => (
              <div key={u.id} className="timeline-item">
                <span className="timeline-dot" />
                <div className="timeline-body">
                  <span className="timeline-date">{formatDate(u.date)}</span>
                  <span className={`update-badge update-badge--${u.type}`}>
                    {u.target}
                  </span>
                  {u.description && (
                    <p className="timeline-desc">{u.description}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default UpdatesTimeline;
